/**
 * web-account-pages D11 — a booking's Complete booking step (`/account/bookings/:bookingId/complete`),
 * for a booking the studio made that waits on the client: the app's step (CompleteStepScreen over
 * useCompleteStep) on the website session. Below 768px the app's screen as it is; on a computer the
 * same step in a centered column under the site's header and the breadcrumb. Signed out, the
 * sign-in step in place.
 *
 * On a studio's custom site the step is the website's own piece (`complete-step`, web-studio-sites
 * D12) at every width, over the same flow.
 *
 * Where it goes and what Back does: the piece's behavior half (`useCompleteStepPiece`).
 */
import { useParams } from 'react-router-dom';

import { CompleteStepColumn, CompleteStepScreen } from '@/pages/CompleteBookingPage/CompleteStepScreen';

import { usePageMover } from '../../pageMover';
import crumbs from '../../pieces/booking-page/BookingPage.module.css';
import { CompleteStepView, useCompleteStepPiece } from '../../pieces/complete-step';
import { readSite } from '../../site';
import shared from '../../styles/shared.module.css';
import { onLink } from '../../ui/onLink';
import { useAppScreens } from '../../ui/useIsPhone';
import { usePageTitle } from '../../ui/usePageTitle';
import { SignedInOnly } from './SignedInOnly';

function Complete() {
  const { bookingId = '' } = useParams<{ bookingId: string }>();
  const navigate = usePageMover();
  const phone = useAppScreens();
  const step = useCompleteStepPiece({ bookingId });
  const bookingPath = `/account/bookings/${encodeURIComponent(bookingId)}`;

  if (phone) return <CompleteStepScreen {...step.screen} />;
  return (
    <div className={`${shared.wrap} ${crumbs.page}`}>
      <nav className={crumbs.crumbs} aria-label="Breadcrumb">
        <a href="/account/bookings" onClick={onLink(() => navigate('/account/bookings'))}>
          Bookings
        </a>
        <span className={crumbs.sep}>/</span>
        <a href={bookingPath} onClick={onLink(() => navigate(bookingPath))}>
          {step.screen.serviceName ?? 'Your booking'}
        </a>
        <span className={crumbs.sep}>/</span>
        <span className={crumbs.here}>Complete booking</span>
      </nav>
      {readSite() ? <CompleteStepView {...step} /> : <CompleteStepColumn {...step.screen} />}
    </div>
  );
}

export function CompletePage() {
  usePageTitle('Complete booking');
  return (
    <SignedInOnly>
      <Complete />
    </SignedInOnly>
  );
}
